export default __webpack_public_path__ + "static/signature-share-02f19b2df8566841341e49914d5fc648.jpg";